import * as React from "react";
import Svg, { Path } from "react-native-svg";

const MenuIcon = ({ color }) => (
  <Svg width={4} height={20} fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path
      d="M2 20c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 .5 18.5c0-.417.146-.77.437-1.063A1.446 1.446 0 0 1 2 17c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062 0 .417-.146.77-.438 1.063A1.446 1.446 0 0 1 2 20Zm0-8.5c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 .5 10c0-.417.146-.77.437-1.063A1.447 1.447 0 0 1 2 8.5c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062 0 .417-.146.77-.438 1.063A1.446 1.446 0 0 1 2 11.5ZM2 3c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 .5 1.5C.5 1.083.646.73.937.437A1.447 1.447 0 0 1 2 0c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062 0 .417-.146.77-.438 1.063A1.447 1.447 0 0 1 2 3Z"
      fill={color || "#fff"}
    />
  </Svg>
);

export default MenuIcon;
